import './ContainerContextMenu.css';
import { SecurityAttributes } from '../../utils/data/enums';
import { useAuthContext } from '../../store/AuthContext';
import { getText } from '../../i18n';

const ContainerContextMenu = ({
    isVisible,
    positionX,
    handlePropertiesClick,
    handleDeleteClick,
}) => {
    const { hasAttribute } = useAuthContext();

    if (!isVisible) {
        return null;
    }

    const style = {
        position: 'absolute',
        backgroundColor: 'white',
        zIndex: '2000',
        marginLeft: positionX - 36,
        alignSelf: 'start',
        marginTop: '42px',
        height: 'fit-content',
        padding: '10px 0px',
    };

    return (
        <div className="card shadow-sm" style={style}>
            <span
                className="container-context-menu-option"
                onClick={handlePropertiesClick}
                style={{ pointerEvents: 'auto' }}
            >
                {getText('msg_bc6c88db2f07')}
            </span>
            {!hasAttribute(SecurityAttributes.PortalsReadOnly) && (
                <span
                    className="container-context-menu-option"
                    onClick={handleDeleteClick}
                    style={{ pointerEvents: 'auto' }}
                >
                    {getText('msg_f6fdbe48dc54')}
                </span>
            )}
        </div>
    );
};

export default ContainerContextMenu;
